export default "__VITE_ASSET__C8D6eNzG__"